import styled from 'styled-components';
export const $List = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
`;
export const $Row = styled.a `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  padding: ${({ theme }) => theme.spacing(1)} 0;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.text.headLine};
  border-bottom: 1px solid ${({ theme }) => theme.colors.greyScales[100]};
  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`;
export const $Filename = styled.span `
  flex: 1;
  font-size: 14px;
  word-break: break-word;
`;
